import { Link } from "react-router-dom";
import {
  Beef, ArrowLeft, Store, ChefHat, MapPin, MessageCircle, Star, Crown,
  ShieldCheck, HandCoins, TrendingUp, Bell, FileSignature, Users, CheckCircle2,
  BarChart3, Route, Clock, Lock, Award, Zap, Filter, KeyRound, Mail, Upload,
  Eye, EyeOff, Ban, RotateCcw, DollarSign, CreditCard, Calendar, Hash,
  UserCheck, Compass, LayoutDashboard, Trophy, Search, Sliders, LogIn, LogOut,
  Sparkles, Gauge, Fingerprint, ScrollText, Globe, Smartphone
} from "lucide-react";

const CATEGORIES = [
  {
    title: "Cadastro & Identidade",
    subtitle: "Quem entra na plataforma é quem diz ser",
    color: "text-red-500",
    items: [
      { icon: Store, title: "Dois fluxos de cadastro", desc: "Comércio (açougue/casa de carnes/supermercado) e Profissional (açougueiro/balconista/desossador/auxiliar) — telas separadas com campos específicos." },
      { icon: Fingerprint, title: "Validação de CPF / CNPJ", desc: "Algoritmo oficial dos dígitos verificadores. CPF só cadastra se for válido; CNPJ idem. Máscara automática enquanto digita." },
      { icon: Hash, title: "Documento único no sistema", desc: "Um CPF só pode cadastrar uma conta. Um CNPJ idem. Bloqueio de conta duplicada." },
      { icon: ScrollText, title: "Aceite LGPD obrigatório", desc: "Checkbox de Termos + Privacidade com data/hora registrada. Sem aceitar, não cria conta." },
      { icon: ChefHat, title: "Especialidade escolhida", desc: "Açougueiro, Balconista, Desossador ou Auxiliar — usado para filtrar vagas mais aderentes." },
      { icon: Compass, title: "Geolocalização do usuário", desc: "Latitude/longitude armazenados no cadastro para calcular distância até as vagas." },
    ],
  },
  {
    title: "Autenticação & Segurança",
    subtitle: "Padrão de banco digital",
    color: "text-emerald-400",
    items: [
      { icon: LogIn, title: "Login JWT com cookie httpOnly", desc: "Token de 7 dias, assinatura HS256, cookie inacessível ao JavaScript — imune a XSS." },
      { icon: KeyRound, title: "Bcrypt para senhas", desc: "Nenhuma senha em texto puro no banco. Salt automático por conta." },
      { icon: Mail, title: "Recuperar senha por email", desc: "Envia link de reset (token seguro urlsafe) com validade de 1 hora. Uso único." },
      { icon: RotateCcw, title: "Redefinir senha", desc: "Tela dedicada de reset. Após atualizar, o token queima e não pode ser reutilizado." },
      { icon: Ban, title: "Anti-enumeração de email", desc: "\"Esqueci senha\" responde igual mesmo se o email não existir — impede bot descobrir contas." },
      { icon: LogOut, title: "Logout com limpeza total", desc: "Apaga cookie do servidor + localStorage do cliente. Sessão zerada." },
      { icon: Lock, title: "CORS restrito", desc: "Só aceita chamadas do domínio oficial + subdomínios Emergent. Origens desconhecidas são rejeitadas." },
      { icon: Eye, title: "Autorização por dono/participante", desc: "Ninguém acessa vaga, chat ou documento que não é seu. Admin tem acesso total." },
    ],
  },
  {
    title: "Publicação e Ciclo de Vida da Diária",
    subtitle: "Da vaga aberta ao pagamento confirmado",
    color: "text-amber-400",
    items: [
      { icon: FileSignature, title: "Criar diária em 30 segundos", desc: "Título, descrição, data, início, fim, valor base, endereço, cidade — vaga vai ao ar imediatamente." },
      { icon: Search, title: "Feed de vagas abertas", desc: "Todos os profissionais veem em tempo real. Cards com título, comércio, distância, valor, horário." },
      { icon: HandCoins, title: "Aceite direto", desc: "Um clique e a vaga é sua. Status muda para \"Aceita\"." },
      { icon: TrendingUp, title: "Contra-oferta transparente", desc: "Profissional propõe valor + mensagem. Comércio vê a lista de ofertas e escolhe a melhor." },
      { icon: CheckCircle2, title: "Aceite de oferta pelo comércio", desc: "Ao aceitar uma proposta, as outras viram \"rejeitadas\" automaticamente. Valor final é atualizado." },
      { icon: FileSignature, title: "Contrato Digital dupla assinatura", desc: "Comércio e profissional assinam com um clique. Registra data, hora e IP de cada assinatura — prova legal." },
      { icon: Gauge, title: "Status \"Em andamento\"", desc: "Quando ambas as partes assinam o contrato, a diária vira \"in_progress\" automaticamente." },
      { icon: DollarSign, title: "Finalizar & confirmar pagamento", desc: "Ao fim do expediente, comércio dá o clique que fecha a diária e libera avaliação." },
      { icon: Ban, title: "Cancelamento com penalidade", desc: "Profissional que cancela zera streak e perde 10 pontos. A vaga volta ao feed automaticamente." },
      { icon: Calendar, title: "Cancelamento pelo comércio", desc: "Comércio pode cancelar até o início. Status vira \"cancelada\" e ninguém pode mais aceitar." },
    ],
  },
  {
    title: "Chat & Comunicação",
    subtitle: "Tudo dentro da plataforma, nada por WhatsApp perdido",
    color: "text-blue-400",
    items: [
      { icon: MessageCircle, title: "Chat por diária", desc: "Cada vaga tem sua própria sala de mensagens. Comércio ↔ profissional." },
      { icon: Zap, title: "Polling em tempo real (4s)", desc: "Mensagens novas aparecem sem recarregar a página. Auto-scroll para o final." },
      { icon: EyeOff, title: "Privacidade de chat", desc: "Só participantes veem. Durante negociação, açougueiro vê apenas suas próprias mensagens + respostas do comércio para ele." },
      { icon: Users, title: "Chat pré-aceite (negociação)", desc: "Profissional pode conversar com o comércio ANTES de aceitar — tirar dúvidas sobre a vaga." },
    ],
  },
  {
    title: "Avaliação & Reputação",
    subtitle: "A confiança da plataforma vira ativo dos usuários",
    color: "text-amber-400",
    items: [
      { icon: Star, title: "Avaliação de 1 a 5 estrelas", desc: "Comércio avalia profissional. Profissional avalia comércio. Ambos veem tudo publicamente." },
      { icon: MessageCircle, title: "Comentário opcional", desc: "Descrição do que foi bom ou ruim. Ajuda outros usuários a decidir." },
      { icon: Ban, title: "Anti-avaliação dupla", desc: "Cada pessoa só avalia uma vez por diária. Bloqueio no banco." },
      { icon: Gauge, title: "Média automática", desc: "Rating médio recalculado a cada avaliação. Aparece no perfil e no ranking." },
      { icon: Trophy, title: "Bônus por avaliação alta", desc: "Profissional que recebe 4★ ou 5★ ganha +20 pontos extras de bônus." },
    ],
  },
  {
    title: "Programa de Fidelidade (anti-furo)",
    subtitle: "Recompensa quem mantém o serviço na plataforma",
    color: "text-red-500",
    items: [
      { icon: Sparkles, title: "+50 pontos por diária concluída", desc: "Toda vez que o expediente termina e o comércio confirma, o profissional ganha 50 pontos." },
      { icon: Sparkles, title: "+20 pontos por avaliação alta", desc: "Recebeu 4 ou 5 estrelas? Ganha 20 pontos extras. Estimula fazer bem feito." },
      { icon: Ban, title: "-10 pontos por cancelamento", desc: "Cancelou depois de aceitar? Perde 10 pontos. Comportamento ruim custa caro." },
      { icon: Award, title: "4 selos de nível", desc: "Bronze (0 pts) → Prata (100 pts) → Ouro (300 pts) → Master (700 pts). Selo aparece em todo lugar." },
      { icon: TrendingUp, title: "Sequência consecutiva", desc: "Contador de diárias sem cancelamento. Cancelou = zera. 5 seguidas libera bônus de +5%." },
      { icon: Trophy, title: "Ranking nacional", desc: "Top 3 no pódio (ouro, prata, bronze visuais) + lista dos demais. Ordenado por pontos e nota." },
    ],
  },
  {
    title: "Selo Verificado (KYC leve)",
    subtitle: "Conta com documento aprovado ganha o selo azul",
    color: "text-blue-400",
    items: [
      { icon: Upload, title: "Upload de RG (profissional)", desc: "Foto do RG ou CNH — JPG, PNG, WEBP ou PDF, até 5MB." },
      { icon: Upload, title: "Upload de cartão CNPJ (comércio)", desc: "Comprovante de existência jurídica do estabelecimento." },
      { icon: Upload, title: "Upload de comprovante de residência", desc: "Conta de luz, água ou telefone recente — confirma endereço." },
      { icon: UserCheck, title: "Revisão do admin", desc: "Admin (você) aprova ou rejeita cada documento. Aparece no painel com status \"em análise\"." },
      { icon: ShieldCheck, title: "Selo azul automático", desc: "Assim que RG + comprovante (ou CNPJ + comprovante) são aprovados, o selo aparece no perfil, dashboard e ranking." },
      { icon: Lock, title: "Documentos privados", desc: "Só o dono e o admin podem baixar. Autenticação obrigatória — nunca em URL pública." },
      { icon: RotateCcw, title: "Substituir documento", desc: "Enviou o errado? Upload novo apaga o anterior (soft-delete) e reinicia a análise." },
    ],
  },
  {
    title: "Mapa Interativo & Descoberta",
    subtitle: "Onde estão as vagas AGORA",
    color: "text-emerald-400",
    items: [
      { icon: MapPin, title: "Mapa Leaflet full-screen", desc: "OpenStreetMap tiles, zoom, pan, pinos personalizados." },
      { icon: Filter, title: "Pinos coloridos por status", desc: "Verde = aberta, amarelo = negociando, azul = aceita, vermelho = cancelada, cinza = concluída." },
      { icon: Sliders, title: "Slider de raio 1-50 km", desc: "Ajusta em tempo real quais vagas aparecem. Círculo pontilhado mostra o alcance visual." },
      { icon: Compass, title: "Botão \"Minha localização\"", desc: "Usa GPS do navegador (com permissão) para centralizar o mapa na posição atual." },
      { icon: Route, title: "Cálculo de distância haversine", desc: "Cada card mostra distância em km da localização do usuário — precisão de curva da Terra." },
      { icon: Eye, title: "Popup interativo", desc: "Clique no pino → título, comércio, data, valor, status e link direto pra diária." },
    ],
  },
  {
    title: "Notificações",
    subtitle: "Ninguém perde uma vaga por descuido",
    color: "text-red-500",
    items: [
      { icon: Bell, title: "Sino no header", desc: "Ícone com badge vermelho mostrando quantidade de não-lidas. Polling a cada 15 segundos." },
      { icon: Bell, title: "Painel de notificações", desc: "Clica no sino, abre lista com título, corpo, link pra vaga e timestamp." },
      { icon: CheckCircle2, title: "Marcar como lidas", desc: "Abrir o painel marca todas como lidas automaticamente." },
      { icon: Mail, title: "Email para todos da cidade", desc: "Nova vaga em São Paulo? Todos os profissionais cadastrados em SP recebem email com link direto." },
      { icon: Mail, title: "Email de boas-vindas", desc: "No cadastro, novo usuário recebe email dark-branded com botão pra entrar." },
      { icon: Ban, title: "Anti-phishing gate", desc: "Sistema recusa enviar email com formulários, pedidos de senha ou domínios encurtados. Zero risco de phishing." },
    ],
  },
  {
    title: "Pagamentos & Monetização",
    subtitle: "Só o comércio paga — e paga barato",
    color: "text-amber-400",
    items: [
      { icon: Crown, title: "Plano Premium R$ 29,90/mês", desc: "Assinatura mensal recorrente para o comércio via Stripe." },
      { icon: Sparkles, title: "14 dias grátis", desc: "Trial automático via Stripe Subscription. Primeira cobrança só no dia 15." },
      { icon: CreditCard, title: "Checkout Stripe", desc: "Redireciona para tela oficial da Stripe. Cartão de crédito, débito, Pix (dependendo do país)." },
      { icon: RotateCcw, title: "Webhook + status polling", desc: "Confirmação dupla — webhook do Stripe + polling do frontend. Idempotente." },
      { icon: DollarSign, title: "0% de retenção sobre diária", desc: "Comércio paga o profissional integral. Plataforma não retém centavo." },
      { icon: HandCoins, title: "Profissional 100% grátis", desc: "Sem taxa de cadastro, sem taxa por vaga, sem taxa de saque. Sempre." },
    ],
  },
  {
    title: "Painel & Dashboards",
    subtitle: "Métricas diferentes para cada perfil",
    color: "text-purple-400",
    items: [
      { icon: LayoutDashboard, title: "Dashboard do Comércio", desc: "Diárias abertas, em andamento, concluídas, total gasto, nota média, status Premium." },
      { icon: LayoutDashboard, title: "Dashboard do Profissional", desc: "Ativas, concluídas, total ganho, pontos, selo atual, sequência de sucesso, nota média." },
      { icon: Gauge, title: "Barra de progresso da fidelidade", desc: "Mostra visualmente quantas diárias faltam pro próximo selo." },
      { icon: Search, title: "Filtros de vagas", desc: "Abertas / Minhas publicações / Minhas aceitas / Todas — um clique cada." },
    ],
  },
  {
    title: "Compliance & LGPD",
    subtitle: "Lei 13.709/2018 no coração do produto",
    color: "text-emerald-400",
    items: [
      { icon: ScrollText, title: "Termos de Uso completos", desc: "Página pública com 10 seções cobrindo cadastro, pagamentos, cancelamento, avaliações, responsabilidades." },
      { icon: ScrollText, title: "Política de Privacidade LGPD", desc: "Página pública citando artigos 7º e 18. Descreve dados coletados, finalidade, compartilhamento, retenção." },
      { icon: UserCheck, title: "Consentimento gravado", desc: "Data/hora exatos de aceite dos termos armazenados no banco por conta." },
      { icon: Mail, title: "Canal de exercício de direitos", desc: "Email do controlador (você) publicado nos Termos para receber pedidos LGPD em até 15 dias." },
      { icon: Lock, title: "Menor privilégio", desc: "APIs retornam apenas campos públicos para terceiros. CPF, telefone, email só para o dono." },
    ],
  },
  {
    title: "Design & Experiência",
    subtitle: "Interface pensada pro brasileiro do açougue",
    color: "text-red-500",
    items: [
      { icon: Globe, title: "100% em português BR", desc: "Sem tradução automática ou termos técnicos em inglês. Linguagem do dia a dia." },
      { icon: Smartphone, title: "Responsivo mobile-first", desc: "Menu hambúrguer no celular, botões grandes, cards que empilham. Testado até 320px de largura." },
      { icon: Sparkles, title: "Tema dark com grão", desc: "Preto profundo + vermelho carne + dourado. Textura de grão sutil pra dar personalidade." },
      { icon: Zap, title: "Fontes com identidade", desc: "Outfit (títulos) + Plus Jakarta Sans (corpo) + JetBrains Mono (números). Nada de Arial genérico." },
      { icon: Bell, title: "Toasts com Sonner", desc: "Notificações discretas no canto superior. Sucesso/erro/info diferenciados por cor." },
      { icon: MessageCircle, title: "Suporte WhatsApp flutuante", desc: "Botão verde permanente em todas as telas. Um clique abre conversa direto com o dono da plataforma." },
    ],
  },
];

const STATS = [
  { value: "R$ 29,90", label: "por mês para o comércio", color: "text-red-500" },
  { value: "R$ 0", label: "sempre para o profissional", color: "text-emerald-400" },
  { value: "14 dias", label: "grátis para testar Premium", color: "text-amber-400" },
  { value: "0%", label: "de retenção sobre a diária", color: "text-blue-400" },
];

const FLOW_STEPS = [
  { n: "01", title: "Comércio publica", desc: "Preenche título, data, horário, endereço, valor base. Publicação em segundos." },
  { n: "02", title: "Profissional descobre", desc: "Vê a vaga no feed e no mapa, com distância em km da própria localização." },
  { n: "03", title: "Aceite ou negociação", desc: "Aceita direto ou envia contra-oferta com mensagem. Comércio decide." },
  { n: "04", title: "Contrato digital assinado", desc: "Ambos assinam com um clique. Registro com data/hora/IP." },
  { n: "05", title: "Expediente cumprido", desc: "Trabalho executado. Chat aberto para tirar dúvidas do dia." },
  { n: "06", title: "Pagamento & avaliação", desc: "Comércio confirma pagamento na hora. Ambos se avaliam. Profissional ganha pontos." },
];

export default function Portfolio() {
  return (
    <div className="min-h-screen grain relative z-10">
      {/* Nav */}
      <header className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 py-5">
        <Link to="/" className="flex items-center gap-2" data-testid="portfolio-logo">
          <div className="w-10 h-10 rounded-xl bg-red-600 flex items-center justify-center">
            <Beef className="w-5 h-5 text-white" />
          </div>
          <span className="font-display font-extrabold text-xl">CarnesWork</span>
        </Link>
        <Link to="/" className="text-sm text-zinc-400 hover:text-white inline-flex items-center gap-2">
          <ArrowLeft className="w-4 h-4" /> Voltar
        </Link>
      </header>

      {/* Hero */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-10 sm:pt-16 pb-16 relative">
        <div className="max-w-3xl anim-fade-up">
          <span className="badge-pill status-open mb-6">📖 Portfólio · Como funciona a plataforma</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-extrabold leading-[1.05] tracking-tight text-white">
            O <span className="text-red-500">99 do açougue</span>. Marketplace de diárias para o setor de carnes.
          </h1>
          <p className="mt-6 text-zinc-300 text-lg leading-relaxed">
            CarnesWork conecta <b className="text-white">açougues, casas de carnes e supermercados</b> a
            <b className="text-white"> açougueiros, balconistas, desossadores e auxiliares</b> em regime de
            diária. Comércios nunca ficam sem profissional; profissionais nunca ficam sem oportunidade.
            Pagamento no fim do expediente. Avaliação em dois sentidos. Reputação vira patrimônio.
          </p>
        </div>

        {/* Stats grid */}
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {STATS.map((s, i) => (
            <div key={i} className="cw-card p-6">
              <div className={`text-3xl sm:text-4xl font-display font-extrabold ${s.color}`}>{s.value}</div>
              <div className="text-xs text-zinc-400 mt-2 uppercase tracking-wider">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Personas */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 relative">
        <div className="mb-10">
          <span className="text-xs uppercase tracking-widest text-red-500 font-bold">Quem usa</span>
          <h2 className="text-3xl sm:text-4xl font-display font-bold mt-2">Dois lados, um só ecossistema</h2>
        </div>
        <div className="grid md:grid-cols-2 gap-5">
          <div className="cw-card p-8">
            <div className="w-12 h-12 rounded-xl bg-red-500/15 flex items-center justify-center mb-4">
              <Store className="w-6 h-6 text-red-500" />
            </div>
            <h3 className="text-2xl font-display font-bold mb-2">Comércio</h3>
            <p className="text-zinc-400 text-sm leading-relaxed mb-4">
              Açougues, casas de carnes e supermercados que precisam suprir folgas, feriados, picos de
              movimento e vagas emergenciais sem ter que ligar 20 números na madrugada.
            </p>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" /> Publica diárias em 30 segundos</li>
              <li className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" /> Recebe candidatos qualificados com histórico e nota</li>
              <li className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" /> Escolhe pelo preço, pela nota ou pelo selo verificado</li>
              <li className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" /> Paga no fim do dia — 0% de retenção da plataforma</li>
            </ul>
          </div>

          <div className="cw-card p-8">
            <div className="w-12 h-12 rounded-xl bg-amber-500/15 flex items-center justify-center mb-4">
              <ChefHat className="w-6 h-6 text-amber-500" />
            </div>
            <h3 className="text-2xl font-display font-bold mb-2">Profissional</h3>
            <p className="text-zinc-400 text-sm leading-relaxed mb-4">
              Açougueiros, balconistas, desossadores e auxiliares que trabalham por diária. Rende dinheiro
              quando querem, viram Master, viram referência regional. Nunca pagam mensalidade.
            </p>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" /> Vê vagas próximas no mapa com raio ajustável</li>
              <li className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" /> Aceita ou negocia o valor com transparência</li>
              <li className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" /> Sobe de selo (Bronze → Master) e ganha prioridade</li>
              <li className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" /> Recebe no fim do expediente — sem intermediário</li>
            </ul>
          </div>
        </div>
      </section>

      {/* User flow */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 relative">
        <div className="mb-10 max-w-2xl">
          <span className="text-xs uppercase tracking-widest text-red-500 font-bold">Fluxo completo</span>
          <h2 className="text-3xl sm:text-4xl font-display font-bold mt-2">Do "preciso de alguém" ao "obrigado, até semana que vem"</h2>
          <p className="text-zinc-400 text-sm mt-3">Toda a jornada acontece dentro da plataforma. Rastreável, auditável, seguro.</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {FLOW_STEPS.map((s, i) => (
            <div key={i} className="cw-card p-6 relative overflow-hidden">
              <div className="absolute -top-3 -right-3 text-7xl font-display font-black text-red-500/10">{s.n}</div>
              <div className="relative">
                <div className="text-xs text-red-500 font-mono font-bold mb-2">STEP {s.n}</div>
                <h3 className="font-display font-bold text-lg mb-2">{s.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* All features grid — categorized */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 relative">
        <div className="mb-10 max-w-3xl">
          <span className="text-xs uppercase tracking-widest text-red-500 font-bold">Funcionalidades completas</span>
          <h2 className="text-3xl sm:text-4xl font-display font-bold mt-2">
            Todo recurso que já está no ar
          </h2>
          <p className="text-zinc-400 text-sm mt-3">
            {CATEGORIES.reduce((n, c) => n + c.items.length, 0)} funcionalidades entregues,
            organizadas em {CATEGORIES.length} categorias. Nada aqui é mockup — tudo roda no servidor.
          </p>
        </div>
        <div className="space-y-12">
          {CATEGORIES.map((cat, ci) => (
            <div key={ci}>
              <div className="flex items-baseline gap-3 mb-4 border-b border-zinc-800 pb-3">
                <span className={`font-mono text-xs ${cat.color} font-bold`}>{String(ci + 1).padStart(2, "0")}</span>
                <div>
                  <h3 className={`text-xl sm:text-2xl font-display font-bold ${cat.color}`}>{cat.title}</h3>
                  <p className="text-xs text-zinc-500 mt-0.5">{cat.subtitle} · {cat.items.length} recursos</p>
                </div>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {cat.items.map((it, i) => (
                  <div key={i} className="cw-card p-5">
                    <div className="flex items-start gap-3 mb-2">
                      <div className="w-9 h-9 rounded-lg bg-zinc-800/60 flex items-center justify-center flex-shrink-0">
                        <it.icon className={`w-4 h-4 ${cat.color}`} />
                      </div>
                      <h4 className="font-display font-bold text-sm leading-tight pt-1.5">{it.title}</h4>
                    </div>
                    <p className="text-xs text-zinc-400 leading-relaxed">{it.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Tech / architecture */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 relative">
        <div className="cw-card p-8 sm:p-10 bg-gradient-to-br from-zinc-900 to-red-950/30">
          <span className="text-xs uppercase tracking-widest text-red-500 font-bold">Arquitetura & Confiança</span>
          <h2 className="text-3xl sm:text-4xl font-display font-bold mt-2 mb-6">Feito com stack sólida, pronta para escalar</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { icon: Zap, title: "React 19 + Tailwind", desc: "Frontend moderno, responsivo, com mapa Leaflet interativo" },
              { icon: BarChart3, title: "FastAPI + MongoDB", desc: "Backend Python assíncrono, indexado, escalável" },
              { icon: Lock, title: "JWT + bcrypt", desc: "Autenticação por cookie httpOnly, senhas em hash forte" },
              { icon: HandCoins, title: "Stripe recorrente", desc: "Assinatura Premium com trial de 14 dias" },
            ].map((t, i) => (
              <div key={i}>
                <t.icon className="w-6 h-6 text-red-500 mb-2" />
                <div className="font-bold text-sm">{t.title}</div>
                <div className="text-xs text-zinc-400 mt-1">{t.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Fidelity ladder */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 relative">
        <div className="mb-10 max-w-2xl">
          <span className="text-xs uppercase tracking-widest text-red-500 font-bold">Programa Fidelidade</span>
          <h2 className="text-3xl sm:text-4xl font-display font-bold mt-2">Como o profissional cresce dentro do CarnesWork</h2>
          <p className="text-zinc-400 text-sm mt-3">Sem esforço extra: só concluindo diárias e sendo bem avaliado, o profissional sobe de nível e ganha prioridade nas melhores vagas.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {[
            { tier: "Bronze", req: "0 pts", color: "border-orange-800 bg-orange-950/30 text-orange-300", desc: "Ponto de partida. Todo profissional novo começa aqui." },
            { tier: "Prata", req: "100 pts", color: "border-zinc-500 bg-zinc-800/50 text-zinc-100", desc: "Sinal de constância. Já apareceu, cumpriu e foi bem avaliado." },
            { tier: "Ouro", req: "300 pts", color: "border-amber-700 bg-amber-950/40 text-amber-300", desc: "Prioridade no feed. Comércios veem primeiro. Bônus de +5%." },
            { tier: "Master", req: "700 pts", color: "border-red-700 bg-red-950/40 text-red-300", desc: "Elite. Emblema. Convite para parcerias exclusivas com redes." },
          ].map(t => (
            <div key={t.tier} className={`p-6 rounded-2xl border-2 ${t.color}`}>
              <Award className="w-6 h-6 mb-3" />
              <div className="font-display font-bold text-2xl">{t.tier}</div>
              <div className="font-mono text-xs mt-1">{t.req}</div>
              <p className="text-xs mt-3 opacity-80 leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Pricing */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 relative">
        <div className="grid md:grid-cols-2 gap-5">
          <div className="cw-card p-8">
            <ChefHat className="w-8 h-8 text-amber-500 mb-4" />
            <div className="text-xs uppercase tracking-wider text-zinc-500">Para o profissional</div>
            <div className="text-5xl font-display font-extrabold mt-2">R$ 0</div>
            <div className="text-zinc-400 text-sm mt-1">Sempre. Sem pegadinha.</div>
            <ul className="mt-6 space-y-2 text-sm text-zinc-300">
              <li>✓ Cadastro grátis</li>
              <li>✓ Todas as vagas visíveis</li>
              <li>✓ Sem taxa sobre a diária</li>
              <li>✓ Selo Verificado sem custo</li>
            </ul>
          </div>
          <div className="cw-card p-8 bg-gradient-to-br from-zinc-900 to-red-950/30 border-red-800">
            <Crown className="w-8 h-8 text-amber-400 mb-4" />
            <div className="text-xs uppercase tracking-wider text-zinc-500">Para o comércio</div>
            <div className="text-5xl font-display font-extrabold mt-2">R$ 29,90<span className="text-lg text-zinc-400 font-normal">/mês</span></div>
            <div className="text-emerald-400 text-sm mt-1 font-semibold">14 dias grátis · cancele quando quiser</div>
            <ul className="mt-6 space-y-2 text-sm text-zinc-300">
              <li>✓ Publicações ilimitadas de diárias</li>
              <li>✓ Prioridade dos açougueiros Ouro/Master</li>
              <li>✓ Painel de gasto e histórico</li>
              <li>✓ Programa de parcerias corporativas</li>
              <li>✓ Suporte via WhatsApp direto</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Roadmap */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 relative">
        <div className="mb-10 max-w-2xl">
          <span className="text-xs uppercase tracking-widest text-red-500 font-bold">Próximos passos</span>
          <h2 className="text-3xl sm:text-4xl font-display font-bold mt-2">Roadmap</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-4">
          {[
            { icon: Bell, title: "Push notification (Firebase)", when: "Curto prazo", desc: "Avisar profissional mesmo com o app fechado." },
            { icon: Users, title: "Programa de indicação", when: "Curto prazo", desc: "Profissional convida outro, ambos ganham 100 pts na primeira diária." },
            { icon: Route, title: "App PWA instalável", when: "Curto prazo", desc: "Ícone no celular, offline first, splash screen." },
            { icon: BarChart3, title: "Portal corporativo", when: "Médio prazo", desc: "Painel para redes de supermercado com múltiplas unidades." },
            { icon: FileSignature, title: "Recibo em PDF assinado", when: "Médio prazo", desc: "Comprovante fiscal por diária concluída." },
            { icon: Clock, title: "Agenda semanal recorrente", when: "Médio prazo", desc: "Comércio programa diárias fixas (ex: todo sábado)." },
          ].map((r, i) => (
            <div key={i} className="cw-card p-6">
              <div className="flex items-center gap-2 mb-3">
                <r.icon className="w-5 h-5 text-red-500" />
                <span className="badge-pill status-negotiating">{r.when}</span>
              </div>
              <h3 className="font-display font-bold mb-1">{r.title}</h3>
              <p className="text-xs text-zinc-400 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 relative">
        <div className="cw-card p-10 text-center bg-gradient-to-br from-red-950/40 to-zinc-900">
          <h2 className="text-3xl sm:text-4xl font-display font-extrabold mb-3">Pronto para conhecer por dentro?</h2>
          <p className="text-zinc-300 mb-6 max-w-xl mx-auto">
            Crie sua conta em 60 segundos. Escolha se é comércio ou profissional. Publique ou aceite sua primeira diária hoje.
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link to="/register?role=comercio" className="cw-btn-primary inline-flex items-center gap-2" data-testid="portfolio-cta-comercio">
              Sou Comércio <TrendingUp className="w-4 h-4" />
            </Link>
            <Link to="/register?role=acougueiro" className="cw-btn-outline inline-flex items-center gap-2" data-testid="portfolio-cta-acougueiro">
              Sou Profissional <HandCoins className="w-4 h-4" />
            </Link>
            <Link to="/login" className="cw-btn-outline inline-flex items-center gap-2" data-testid="portfolio-cta-login">
              Já tenho conta →
            </Link>
          </div>
        </div>
      </section>

      <footer className="max-w-7xl mx-auto px-4 sm:px-6 py-10 text-center text-xs text-zinc-500 border-t border-zinc-900 mt-10">
        <div className="flex items-center justify-center gap-4 mb-3">
          <Link to="/" className="hover:text-white">Início</Link>
          <span className="text-zinc-700">·</span>
          <Link to="/terms" className="hover:text-white">Termos</Link>
          <span className="text-zinc-700">·</span>
          <Link to="/privacy" className="hover:text-white">Privacidade</Link>
        </div>
        © 2026 CarnesWork · Marketplace de diárias para o setor de carnes do Brasil.
      </footer>
    </div>
  );
}
